import { Component, Input } from '@angular/core';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
  selector: 'psc-date-input',
  templateUrl: './date-input.component.html'
})
export class DateInputComponent  extends InputWrapperComponent<string>{

  @Input() placeholder: string;
  @Input() readonly = false;

}
